import { StyleSheet } from 'aphrodite';
import { aceGray, white } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';
import { THEME } from '../../Theme/theme';

const generatingContentAnimation = {
	'0%': {
		backgroundPosition: '0% 50%',
	},
	'50%': {
		backgroundPosition: '100% 50%',
	},
	'100%': {
		backgroundPosition: '0% 50%',
	},
};

export const styleSheet = StyleSheet.create({
	generatingContent: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundImage: `linear-gradient(to right,color-mix(in oklab, ${THEME.colors.primary.main} 50%, white), color-mix(in oklab, ${THEME.colors.tertiary.dark} 50%, white))`,
		backgroundSize: '180% 180%',
		backdropFilter: 'opacity(30%)',
		animationName: [generatingContentAnimation],
		animationDuration: '9s',
		animationIterationCount: 'infinite',
		border: `1px solid ${aceGray}`,
		borderRadius: 8,
		padding: 10,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		overflow: 'hidden',
		opacity: 0,
		transition: 'opacity .3s ease-in-out, z-index .3s ease-in-out',
		zIndex: -1,
		...CssSelectors.allChildren({
			color: white,
		}),

		...CssSelectors.allChildren(
			{
				'--size': '20vmin',
				'--holes': 'calc(var(--size)*.495)',
				width: 'var(--size)',
				aspectRatio: '1/1',
				position: 'fixed',
				background: white,
				'--mask':
					'radial-gradient(var(--holes) at var(--holes) var(--holes), #0000 99%,#000) calc(var(--holes)*-1) calc(var(--holes)*-1)',
				'-webkit-mask': 'var(--mask)',
				mask: 'var(--mask)',
				borderRadius: '50%',
				animation: '1s linear forwards',
				animationName: [
					{
						'0%': { transform: 'scale(0)' },
						'25%': { opacity: 1 },
						'100%': { opacity: 0 },
					},
				],
			},
			'.star'
		),
	},
	generatingContentActive: {
		opacity: 1,
		zIndex: 999,
	},
});
